export enum fileValidationErrorType {
    undefined = 0,
    invalidHeaders = 1,
    invalidValue=2,
    missingRequiredValue = 3,
    outOfSafeLimitOfRows = 4
}